module.exports = __webpack_public_path__ + "Roboto-Black.fdd88b742a9f6304f05b.woff";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/googleapi-fonts/Roboto-Black.woff
// module id = ../../../../../src/assets/vendors/base/fonts/googleapi-fonts/Roboto-Black.woff
// module chunks = styles